<template>
  <content-dialog
    v-model="dialogOpen"
    fullscreen-tablet
    no-backdrop-dismiss
    title="Edit Client"
    width="775px"
    max-height="80vh"
    min-height="25vh"
    :loading="loading"
    :card-visible="!!client"
    :tags="[helpCodes.createClient, helpCodes.clients]"
    @hide="closeModal"
  >
    <GeneralPartial
      v-if="!!client && !!options"
      :client="client"
      :options="options"
      :errors="errors"
      mode="edit"
    />

    <template #bottom>
      <q-toolbar v-if="!!client">
        <q-space />
        <q-btn
          color="green"
          icon-right="done"
          label="Save Changes"
          :loading="loading"
          @click="editClient"
        />
      </q-toolbar>
    </template>
  </content-dialog>
</template>

<script>
import GeneralPartial from './panels/General'

export default {
  components: {
    GeneralPartial
  },
  emits: ['close', 'reload'],
  data () {
    return {
      dialogOpen: false,
      loading: false,
      client: null,
      errors: {},
      options: null
    }
  },
  methods: {
    open (client) {
      this.client = JSON.parse(JSON.stringify(client))
      this.dialogOpen = true
      this.loadNewClientDefaults()
    },
    closeModal () {
      this.$emit('close')
    },
    /* Edit Client */
    async editClient () {
      if (this.client.is_individual) {
        this.client.display_name = this.client.first_name + ' ' + this.client.last_name
      }

      this.loading = true
      this.errors = {}
      const { status, errors } = await this.$put('v1/clients', this.client)
      this.loading = false
      if (status === 'success') {
        this.dialogOpen = false
        this.$q.notify({
          message: 'Client successfully updated',
          color: 'green'
        })
        /* Reload their details */
        this.$store.commit('clientSuggestionLoader/removeClientAddresses', this.client.id)
        this.$store.commit('clientSuggestionLoader/removeClientEmails', this.client.id)
        this.$store.commit('clientSuggestionLoader/removeClientPhones', this.client.id)

        this.$emit('reload')
        this.$bus.emit('clients:reload', true)
      }
      else {
        this.errors = errors
        this.$nextTick(() => { this.scrollToFirstError(this.$el) })
      }
    },
    async loadNewClientDefaults () {
      this.loading = true
      const { status, payload } = await this.$get('v1/clients/defaults')
      this.loading = false
      if (status === 'success') {
        this.options = payload
      }
    }
  }
}
</script>
